import * as yup from 'yup';
import { MessageConstant } from '../MessageConstant';

const message = MessageConstant.common;

export const accountTerminalValidation: { [x: string]: any; } = {
  accountTmlReasonCode: yup.string().required(message.MISSING),
};
export const updateAccountTerminalValidation: { [x: string]: any; } = {
  ...accountTerminalValidation,
};

export const updateAccountTerminalValidationSchema = yup.object().shape(updateAccountTerminalValidation);

